module.exports = __webpack_public_path__ + "static/media/github-logo.04f6798f.svg";